import logo from "../../assets/images/logo/bloqcube_logo.png";

const Logo = () => {
  return <img src={logo} alt="Bloqcube" width="100" />;
};

export default Logo;
